import { cn } from "~/lib/utils";
import React from "react";

// // // //

/**
 * DollarSign
 * Renders an DollarSign
 */
export function DollarSign(props: { className?: string }) {
    const { className = "" } = props;
    return (
        <span
            className={cn("text-green-700", {
                [className]: className !== "",
            })}
        >
            $
        </span>
    );
}
